<div class="nb-page-header">
  <div>
    <span class="title">{{ task?.processTitle }}</span>
  </div>
  <!--  <div>-->
  <!--    <button nz-button *ngFor='let op of operations' [nzType]='op.type'-->
  <!--            (click)='popSubmitTask(op)'>{{ op.name }}</button>-->
  <!--  </div>-->
</div>
<div class="full-panel equal-height" style="margin-left: 0">
  <!--  <div class='right-panel' style='width: 76%'>-->
  <nz-card class="container" style="width: 76%; margin-right: 10px">
    <nz-card-tab>
      <nz-tabset *ngIf="forms" [(nzSelectedIndex)]="index" (nzSelectedIndexChange)="changeIndex($event)">
        <nz-tab *ngFor="let t of forms" [nzTitle]="t.displayName"></nz-tab>
        <!--        <nz-tab nzTitle="审批信息"></nz-tab>-->
      </nz-tabset>
    </nz-card-tab>
    <div [style.display]="isFormVisible" [ngClass]="auditShow ? 'apply-info-content-deal' : 'apply-info-content-deal-init'">
      <nb-form-viewer
        [formGroup]="currentGroup"
        [form]="currentForm"
        [data]="currentData"
        [downloadUrl]="downloadUrl"
        [uploadUrl]="uploadUrl"
        [importUrl]="importUrl"
        [token]="token"
        [pdfUrl]="pdfUrl"
      ></nb-form-viewer>
    </div>

    <div class="form-part-border"></div>

    <div>
      <div *ngIf="auditShow" style="display: flex; justify-content: space-between">
        <nz-card nzBorderless nzSize="small" class="indicator-card" nzTitle="审核意见" style="position: relative; width: 50%">
          <div class="is-require" *ngIf="submitAction?.reasonRequired">*</div>
          <textarea
            style="width: 100%"
            nz-input
            placeholder="请输入意见"
            [(ngModel)]="comment"
            [nzAutosize]="{ minRows: 5, maxRows: 5 }"
          ></textarea>
        </nz-card>
        <nz-card nzBorderless nzSize="small" class="indicator-card" nzTitle="审核签名" style="position: relative; width: 50%">
          <div class="is-require" *ngIf="submitAction?.signRequired">*</div>
          <nb-signature [token]="token" [downloadUrl]="downloadUrl" [uploadUrl]="uploadUrl" [(ngModel)]="sign"></nb-signature>
        </nz-card>
      </div>

      <div style="display: flex; justify-content: space-around; align-items: stretch; padding: 30px 18% 10px 18%; position: relative">
        <div style="position: absolute; right: 10px; top: 10px">
          <div *ngIf="!auditShow" class="flow-up-down-box" (click)="auditShow = true">
            <img class="shrink-img" src="../../../../assets/img/flow-up.svg" alt="" />展开
          </div>
          <div *ngIf="auditShow" class="flow-up-down-box" (click)="auditShow = false">
            <img class="shrink-img" src="../../../../assets/img/flow-down.svg" alt="" />收起
          </div>
        </div>
        <div *ngFor="let op of operations" nz-popconfirm [nzPopconfirmTitle]="op.tip" (nzOnConfirm)="submitTask(op)">
          <button style="min-width: 28%" nz-button [nzType]="op.type">{{ op.name }}</button>
        </div>
      </div>
    </div>
  </nz-card>
  <!--  </div>-->

  <div class="left-panel" style="width: 24%">
    <h1 class="title">{{ ticket.nodeName }}</h1>
    <!--    <div class="audit-tip-box"><div class="deal-audit-tip">待处理</div></div>-->
    <nz-card *ngIf="meta" nzBorderless nzSize="small" class="indicator-card" [nzTitle]="meta.displayName">
      <div class="applicant">
        <sv-container [col]="1">
          <ng-container *ngIf="meta && meta.fields">
            <sv *ngFor="let mt of meta.fields" [label]="mt.title">{{ explainMeta(mt) }}</sv>
          </ng-container>
        </sv-container>
      </div>
      <div class="nb-divider"></div>
    </nz-card>

    <nz-card nzBorderless nzSize="small" class="indicator-card" nzTitle="抄送信息">
      <div class="make-copy-frame">
        <div class="copy-each" *ngFor="let op of task?.ccUsers">
          <div class="copy-img-box">
            <div class="bg-img">
              <img
                class="copy-img"
                [src]="userMap[op] && userMap[op].avatar ? downLoad + userMap[op].avatar : '../../../../assets/picture/init-img.png'"
              />
            </div>
          </div>
          <div>{{ userMap[op] ? userMap[op].name : '-' }}</div>
        </div>
      </div>
      <div class="nb-divider"></div>
    </nz-card>

    <!--    <nz-card nzBorderless nzSize='small' class='indicator-card' nzTitle='抄送信息'>-->
    <!--      <sv-container [col]='1' class='applicant'>-->
    <!--        <sv label='抄送职能'>-->
    <!--          <nz-tag *ngFor='let op of task?.processCcRoles'-->
    <!--                  [nzColor]="'blue'">{{roleMap[op] ? roleMap[op].name : '-'}}</nz-tag>-->
    <!--        </sv>-->
    <!--        <sv label='抄送员工'>-->
    <!--          <nz-tag *ngFor='let op of task?.processCcUsers'-->
    <!--                  [nzColor]="'purple'">{{userMap[op] ? userMap[op].name : '-'}}</nz-tag>-->
    <!--        </sv>-->
    <!--        <sv label='追加抄送'>-->
    <!--          <nz-tag *ngFor='let op of task?.ccUsers'-->
    <!--                  [nzColor]="'volcano'">{{userMap[op] ? userMap[op].name : '-'}}</nz-tag>-->
    <!--        </sv>-->
    <!--      </sv-container>-->
    <!--      <div class='nb-divider'></div>-->
    <!--    </nz-card>-->

    <nz-card nzBorderless nzSize="small" class="indicator-card" nzTitle="审核信息">
      <div>
        <div *ngFor="let op of history; let i = index" class="audit-each">
          <div class="left-time">{{ op.date }}</div>
          <div class="right-info">
            <div class="title">
              <img
                *ngIf="!op.isCurrent && (i == 0 || i == history.length - 1)"
                class="title-left-img"
                src="../../../../assets/picture/audit-start.png"
                alt="icon"
              />
              <img
                *ngIf="op.routeName == '驳回' || op.routeName == '关闭'"
                class="title-left-img"
                src="../../../../assets/picture/audit-refuse.png"
                alt="icon"
              />
              <img
                *ngIf="!op.isCurrent && i != 0 && i != history.length - 1 && op.routeName != '驳回' && op.routeName != '关闭'"
                class="title-left-img"
                src="../../../../assets/picture/audit-agree.png"
                alt="icon"
              />
              <img
                *ngIf="op.isCurrent && op.taskStatus != 2 && op.taskStatus != 3"
                class="title-left-img"
                src="../../../../assets/picture/await.png"
                alt="icon"
              />
              <img
                *ngIf="op.isCurrent && (op.taskStatus == 2 || op.taskStatus == 3) && i == history.length - 1"
                class="title-left-img"
                src="../../../../assets/picture/audit-start.png"
                alt="icon"
              />
              {{ op.nodeName }}
            </div>
            <div *ngIf="!op.isCurrent" class="detail-info" [style]="i == history.length - 1 ? { 'border-left': 'none' } : ''">
              <div *ngIf="op.operatorName && op.routeName" class="des">
                {{ op.operatorName
                }}<span [ngClass]="op.routeName == '驳回' || op.routeName == '关闭' ? 'audit-detail disagree' : 'audit-detail agree'">{{
                  op.routeName
                }}</span>
                任务
              </div>
              <div *ngIf="op.comment" class="comment">{{ op.comment }}</div>
              <div *ngIf="op.singImg" class="sign">查看签字 <img class="sign-img" [src]="op.singImg" alt="icon" /></div>
            </div>
            <div
              *ngIf="op.isCurrent && op.taskStatus != 2 && op.taskStatus != 3"
              class="detail-info"
              [style]="i == history.length - 1 ? { 'border-left': 'none' } : ''"
            >
              <div class="deal">等待处理</div>
            </div>
          </div>
        </div>
      </div>
      <!--      <div class="nb-divider"></div>-->
    </nz-card>

    <!--    <nz-card nzBorderless nzSize='small' class='indicator-card' nzTitle='流转记录'>-->
    <!--      <nz-timeline *ngIf='history' class='history'>-->
    <!--        <ng-template #dotTemplate>-->
    <!--          <i nz-icon nzType='clock-circle-o' style='font-size: 16px;'></i>-->
    <!--        </ng-template>-->
    <!--        <ng-container *ngFor='let op of history'>-->
    <!--          <nz-timeline-item *ngIf='op.isCurrent' [nzDot]='op.taskStatus==1 ? dotTemplate : undefined'-->
    <!--                            [nzColor]='statusTag[op.taskStatus].color'-->
    <!--          >-->
    <!--            <nz-tag [nzColor]='statusTag[op.taskStatus].color'>{{statusTag[op.taskStatus].text}}</nz-tag>-->
    <!--          </nz-timeline-item>-->
    <!--          <nz-timeline-item *ngIf='!op.isCurrent' nzColor='green'>-->
    <!--            <p>{{op.operatorName}} <span class='action'>{{op.routeName}}</span> 任务： {{op.comment}}</p>-->
    <!--            <p class='time'>{{op.committedAt | date: 'yyyy-MM-dd HH:mm:ss'}} {{op.nodeName}}</p>-->
    <!--          </nz-timeline-item>-->
    <!--        </ng-container>-->
    <!--      </nz-timeline>-->
    <!--    </nz-card>-->
  </div>
</div>

<!--<nz-modal-->
<!--  [(nzVisible)]='showSubmitModal'-->
<!--  [nzTitle]="submitAction ? submitAction.name : '审批意见'"-->
<!--  (nzOnCancel)='showSubmitModal = false'-->
<!--  (nzOnOk)='submitTask()'>-->
<!--  <ng-container *nzModalContent>-->
<!--    <div nz-row [nzGutter]='24' class='mb-sm'>-->
<!--      <nz-form-label nz-col [nzRequired]='submitAction?.reasonRequired' [nzSpan]='4'>意见</nz-form-label>-->
<!--      <nz-form-control nz-col [nzSpan]='20'>-->
<!--        <textarea style='width: 100%' nz-input placeholder='请输入意见' [(ngModel)]='comment'-->
<!--                  [nzAutosize]='{ minRows: 10 }'></textarea>-->
<!--      </nz-form-control>-->
<!--    </div>-->
<!--    <div nz-row [nzGutter]='24'>-->
<!--      <nz-form-label nz-col [nzRequired]='submitAction?.signRequired' [nzSpan]='4'>签名</nz-form-label>-->
<!--      <nz-form-control nz-col [nzSpan]='20'>-->
<!--        <nb-signature [token]='token' [downloadUrl]='downloadUrl' [uploadUrl]='uploadUrl'-->
<!--                      [(ngModel)]='sign'></nb-signature>-->
<!--      </nz-form-control>-->
<!--    </div>-->
<!--  </ng-container>-->
<!--</nz-modal>-->
